import React, { useState, useCallback, useEffect } from 'react'
import { Button, Drawer, Modal, Space, Switch, message as antMessage } from 'antd'
import { SettingOutlined, DashboardOutlined, PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons'
import AccountInteractionList from './interaction/AccountInteractionList'
import InteractionDetail from './interaction/InteractionDetail'
import ToolPanel from './interaction/ToolPanel'
import AutoReplyPanel from './interaction/AutoReplyPanel'
import DashboardPanel from './interaction/DashboardPanel'
import api from '../api'

function InteractionPage() {
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [selectedIds, setSelectedIds] = useState([])
  const [templates, setTemplates] = useState([])
  const [selectedTemplateContent, setSelectedTemplateContent] = useState('')
  const [autoReplyRunning, setAutoReplyRunning] = useState(false)
  const [autoReplyDrawerOpen, setAutoReplyDrawerOpen] = useState(false)
  const [dashboardModalOpen, setDashboardModalOpen] = useState(false)

  useEffect(() => {
    api.listTemplates().then(res => setTemplates(res.templates || []))
    api.getAutoReplyStatus().then(res => setAutoReplyRunning(res.running))
  }, [])

  const handleSelectAccount = useCallback((acc) => {
    setSelectedAccount(acc)
    setSelectedIds(prev => prev.includes(acc.account_id) ? prev : [...prev, acc.account_id])
  }, [])

  const handleToggleSelect = useCallback((id) => {
    setSelectedIds(prev => {
      const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
      if (next.length === 0) setSelectedAccount(null)
      else if (next.length === 1) {
        const acc = selectedAccount
      }
      return next
    })
  }, [selectedAccount])

  const handleTemplateSelect = useCallback((content) => {
    setSelectedTemplateContent(content)
  }, [])

  const handleAutoReplyToggle = async () => {
    if (autoReplyRunning) {
      await api.stopAutoReply()
      setAutoReplyRunning(false)
      antMessage.success('自动回复已停止')
    } else {
      await api.startAutoReply()
      setAutoReplyRunning(true)
      antMessage.success('自动回复已启动')
    }
  }

  return (
    <div style={{ flex: 1, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{
        padding: '6px 16px', borderBottom: '1px solid #e8e8e8',
        display: 'flex', alignItems: 'center', gap: 10,
        background: '#fff', flexShrink: 0
      }}>
        <span style={{ fontSize: 15, fontWeight: 600, marginRight: 8 }}>粉丝互动</span>

        <Space size="small">
          <Switch
            checked={autoReplyRunning}
            onChange={handleAutoReplyToggle}
            checkedChildren={<span style={{ fontSize: 11 }}>自动</span>}
            unCheckedChildren={<span style={{ fontSize: 11 }}>手动</span>}
          />
          <span style={{ fontSize: 12, color: autoReplyRunning ? '#52c41a' : '#999' }}>
            {autoReplyRunning ? '运行中' : '已停止'}
          </span>
        </Space>

        <div style={{ flex: 1 }} />

        <Button size="small" icon={<SettingOutlined />} onClick={() => setAutoReplyDrawerOpen(true)}>
          自动回复规则
        </Button>
        <Button size="small" icon={<DashboardOutlined />} onClick={() => setDashboardModalOpen(true)}>
          数据看板
        </Button>
      </div>

      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        <div style={{ width: 270, flexShrink: 0 }}>
          <AccountInteractionList
            onSelect={handleSelectAccount}
            selectedIds={selectedIds}
            onToggleSelect={handleToggleSelect}
          />
        </div>

        <div style={{ flex: 1, overflow: 'hidden', borderRight: '1px solid #e8e8e8' }}>
          <InteractionDetail
            selectedAccount={selectedAccount}
            selectedAccounts={selectedIds}
            templates={templates}
            selectedTemplateContent={selectedTemplateContent}
            onTemplateUsed={() => setSelectedTemplateContent('')}
          />
        </div>

        <div style={{ width: 270, flexShrink: 0 }}>
          <ToolPanel onTemplateSelect={handleTemplateSelect} />
        </div>
      </div>

      <Drawer
        title="自动回复规则"
        open={autoReplyDrawerOpen}
        onClose={() => setAutoReplyDrawerOpen(false)}
        width={560}
      >
        <AutoReplyPanel />
      </Drawer>

      <Modal
        title="互动数据看板"
        open={dashboardModalOpen}
        onCancel={() => setDashboardModalOpen(false)}
        footer={null}
        width={800}
      >
        <DashboardPanel />
      </Modal>
    </div>
  )
}

export default InteractionPage
